import type en from './en';

const nl: typeof en = {
  app: {
    loading: 'Laden...',
    somethingWentWrong: 'Er is iets misgegaan',
    pageNotFound: 'Pagina niet gevonden',
    signInFailed: 'Aanmelden mislukt',
    close: 'Sluiten',
  },
  welcome: {
    logoAlt: 'Weekly Squads',
    tagline:
      'Een dagelijks pack-opening spel waarin je je ploeg samenstelt voor de wedstrijden van het weekend',
    cta: 'Aanmelden of registreren',
  },
  nav: {
    locked: 'Vergrendeld',
  },
  lobby: {
    prize: 'Prijs:',
    monthlyPrize: 'Maandprijs:',
    totals: {
      tackles: 'Tackles',
      intercepts: 'Intercepties',
      shots: 'Schoten',
      goals: 'Goals',
      pts: 'Ptn',
    },
    stats: 'T {{tackles}} • I {{interceptions}} • S {{shots}} • G {{goals}}',
    expiresIn: 'Vervalt over {{time}}',
    revealIn: 'Opent over {{time}}',
    drawing: 'Je ploeg wordt geloot…',
    enterError:
      'Je ploeg kon niet geloot worden. Sluit en open opnieuw om het nog eens te proberen.',
    opensIn: '{{round}} opent over {{time}}.',
    openError: 'Dit pack kon niet geopend worden. Sluit en probeer opnieuw.',
    lockError: 'Die speler kon niet vastgelegd worden. Probeer het opnieuw.',
    squadDetails: 'Ploegdetails',
    homeFixture: 'vs {{club}} {{time}}',
    awayFixture: '@{{club}} {{time}}',
  },
  card: {
    expired: 'Verlopen',
    expiredOn: 'Verlopen op {{date}}',
    pickYourPlayer: 'Kies je speler',
    choosePlayer: 'Kies speler',
    revealPlayer: 'Onthul speler',
  },
  position: {
    Attacker: 'Aanvaller',
    Midfielder: 'Middenvelder',
    Defender: 'Verdediger',
    Goalkeeper: 'Doelman',
  },
  reveal: {
    title: 'Onthulling van vandaag',
    lockedTitle: 'Speler vastgelegd',
    swipeSub: 'Swipe om spelers te bekijken. Tik om te kiezen.',
    selectedSub: 'Speler gekozen. Leg vast om te bevestigen.',
    lockedSub: 'Toegevoegd aan je weekploeg.',
    showPlayer: 'Toon speler {{n}}',
    lockIn: 'Speler vastleggen',
    viewSquad: 'Bekijk weekploeg',
    tapHint: 'Tik op 1 speler om te kiezen',
  },
  sheet: {
    leaderboard: 'Klassement',
    weekly: 'Week',
    monthly: 'Maand',
    rank: 'Plaats',
    user: 'Speler',
    shots: 'Schoten',
    goals: 'Goals',
    pts: 'Ptn',
    you: 'Jij',
    empty: 'Nog geen deelnemers — het klassement vult zich naarmate ploegen geloot worden.',
  },
  info: {
    howToPlay: 'Hoe spelen',
    title: 'Hoe spelen',
    rules: [
      'Open elke dag van maandag tot vrijdag een gratis spelerspack en stel je ploeg samen voor de wedstrijden van het weekend.',
      'Elk pack gaat open op het geplande onthullingsmoment — mis je het venster, dan vervalt de plaats.',
      'Je onthulde spelers scoren punten op echte wedstrijdgebeurtenissen: {{goal}} voor een goal, {{shot}} voor een schot op doel, {{tackle}} voor een tackle en {{interception}} voor een interceptie.',
      'Gouden kaarten zijn zeldzamer — hou de gouden versie in de gaten.',
      'Klim in het klassement — elke ronde gaan er prijzen naar een reeks eindposities.',
    ],
    logOut: 'Afmelden',
    account: 'Account',
    officialRules: 'Officieel reglement',
    language: 'Taal',
  },
  countdown: {
    day_one: '{{count}} dag',
    day_other: '{{count}} dagen',
  },
  prize: {
    ordinal_one: '{{count}}e',
    ordinal_two: '{{count}}e',
    ordinal_few: '{{count}}e',
    ordinal_other: '{{count}}e',
    range: '{{from}} tot {{to}}',
  },
};

export default nl;
